import { createSlice } from "@reduxjs/toolkit";
import {
  postUploadImage,
  getUploadImage,
  postUploadGalleryRoom,
  getUploadGalleryRoom,
  postUploadGalleryAsset,
  getUploadGalleryAsset,
  deleteGalleryAsset,
  deleteGalleryRoom,
  getGalleryAssetManage,
  getProfiles,
  deleteProfiles,
  editGalleryRoom,
  editProfiles,
} from "../../API/UploadAssetAPI";

const initialState = {
  Image: [],
  ProfileRoom: [],
  DeleteProfile: [],
  EditProfile: [],
  ResultImage: [],
  GalleryRoom: [],
  EditGalleryRoom: [],
  DeleteGalleryRoom: [],
  ResultGalleryRoom: [],
  GalleryAsset: [],
  DeleteGalleryAsset: [],
  ResultGalleryAsset: [],
  GalleryAssetManage: [],
  loading: false,
};

export const UploadAssetSlice = createSlice({
  name: "UploadState",
  initialState,
  reducers: {
    updatePostUploadImage: (state, action) => {
      state.Image = action.payload;
    },
    updateGetUploadImage: (state, action) => {
      state.ProfileRoom = action.payload;
    },
    updatePostUploadGalleryRoom: (state, action) => {
      state.GalleryRoom = action.payload;
    },
    updateGetUploadGalleryRoom: (state, action) => {
      state.ResultGalleryRoom = action.payload;
    },
    updatePostUploadGalleryAsset: (state, action) => {
      state.GalleryAsset = action.payload;
    },
    updateGetUploadGalleryAsset: (state, action) => {
      state.ResultGalleryAsset = action.payload;
    },
    updateDeleteGalleryAsset: (state, action) => {
      state.DeleteGalleryAsset = action.payload;
    },
    updateDeleteGalleryRoom: (state, action) => {
      state.DeleteGalleryRoom = action.payload;
    },
    updateGetGalleryAssetManage: (state, action) => {
      state.GalleryAssetManage = action.payload;
    },
    updateGetProfiles: (state, action) => {
      state.ResultImage = action.payload;
    },
    updateDeleteProfiles: (state, action) => {
      state.DeleteProfile = action.payload;
    },
    updateEditGalleryRoom: (state, action) => {
      state.EditGalleryRoom = action.payload;
    },
    updateEditProfileRoom: (state, action) => {
      state.EditProfile = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Image //
export const { setLoading } = UploadAssetSlice.actions;
export const { updatePostUploadImage } = UploadAssetSlice.actions;
export const postUploadImageDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await postUploadImage(value);

    const idImage = data.idImage;

    await dispatch(updatePostUploadImage(data));

    if (idImage) {
      await dispatch(
        getUploadImageDetail({
          idImage: idImage,
        })
      );
    }
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error("Error in postUploadImageDetail:", error);
    dispatch(setLoading(false));
  }
};

export const { updateGetUploadImage } = UploadAssetSlice.actions;
export const getUploadImageDetail = (value) => async (dispatch) => {
  const data = await getUploadImage(value);

  await dispatch(updateGetUploadImage(data));
};

// Gallery //
export const { updatePostUploadGalleryRoom } = UploadAssetSlice.actions;
export const postUploadGalleryRoomDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await postUploadGalleryRoom(value);

    const idGallery = data.idGallery;

    await dispatch(updatePostUploadGalleryRoom(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error("Error in postUploadGalleryRoomDetail:", error);
    dispatch(setLoading(false));
  }
};

export const { updateGetUploadGalleryRoom } = UploadAssetSlice.actions;
export const getUploadGalleryRoomDetail = (value) => async (dispatch) => {
  try {
    const data = await getUploadGalleryRoom(value);

    await dispatch(updateGetUploadGalleryRoom(data));
  } catch (error) {
    console.error("Error in getUploadGalleryRoomDetail:", error);
  }
};

// Asset //
export const { updatePostUploadGalleryAsset } = UploadAssetSlice.actions;
export const postUploadGalleryAssetDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await postUploadGalleryAsset(value);

    const idAssetGallery = data.idAssetdetail;

    await dispatch(updatePostUploadGalleryAsset(data));
    dispatch(setLoading(false));

    return data;
  } catch (error) {
    console.error("Error in postUploadGalleryRoomDetail:", error);
    dispatch(setLoading(false));
  }
};

export const { updateGetUploadGalleryAsset } = UploadAssetSlice.actions;
export const getUploadGalleryAssetDetail = (value) => async (dispatch) => {
  try {
    const data = await getUploadGalleryAsset(value);

    await dispatch(updateGetUploadGalleryAsset(data));
    // return data;
  } catch (error) {
    console.error("Error in getUploadGalleryAssetDetail:", error);
  }
};

export const { updateDeleteGalleryAsset } = UploadAssetSlice.actions;
export const deleteUploadGalleryAssetDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await deleteGalleryAsset(value);

    await dispatch(updateDeleteGalleryAsset(data));
    dispatch(setLoading(false));
    //   await dispatch(stopLoading());
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateDeleteGalleryRoom } = UploadAssetSlice.actions;
export const deleteUploadGalleryRoomDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await deleteGalleryRoom(value);

    await dispatch(updateDeleteGalleryRoom(data));
    dispatch(setLoading(false));
    //   await dispatch(stopLoading());
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateGetGalleryAssetManage } = UploadAssetSlice.actions;
export const getGalleryAssetManageDetail = (value) => async (dispatch) => {
  try {
    const data = await getGalleryAssetManage(value);

    await dispatch(updateGetGalleryAssetManage(data));
    // return data;
  } catch (error) {
    console.error("Error in getUploadGalleryAssetDetail:", error);
  }
};

export const { updateGetProfiles } = UploadAssetSlice.actions;
export const getProfilesDetails = (value) => async (dispatch) => {
  try {
    const data = await getProfiles(value);

    await dispatch(updateGetProfiles(data));
    // return data;
  } catch (error) {
    console.error("Error in getProfiles:", error);
  }
};

export const { updateDeleteProfiles } = UploadAssetSlice.actions;
export const deleteProfileRoomDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await deleteProfiles(value);

    await dispatch(updateDeleteProfiles(data));
    dispatch(setLoading(false));
    //   await dispatch(stopLoading());
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateEditGalleryRoom } = UploadAssetSlice.actions;
export const editGalleryRoomDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editGalleryRoom(value);

    const idGallery = data.idGallery;

    await dispatch(updateEditGalleryRoom(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error("Error in postUploadGalleryRoomDetail:", error);
    dispatch(setLoading(false));
  }
};

export const { updateEditProfileRoom } = UploadAssetSlice.actions;
export const editProfileRoomDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editProfiles(value);

    await dispatch(updateEditProfileRoom(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error("Error in postUploadGalleryRoomDetail:", error);
    dispatch(setLoading(false));
  }
};

export default UploadAssetSlice.reducer;
